const jwt = require("jsonwebtoken") as JwtActions;
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { VuexContext } from "@mv/flow-shared-utils/types/vuex";
import { getCookie } from "@/utils/cookie";
import { handleErrors } from "@/utils/handle-errors";
import { JwtActions } from "@/interfaces/sdk-login";

function getEnvironmentId() {
  const token = getCookie("access_token");
  const decodedValue = jwt.decode(token);
  const urlAppendix = `?environmentId=${decodedValue.environment.id}&user=${decodedValue.user_name}&logged-user-id=${decodedValue.user_name}`;
  return urlAppendix;
}

export const actions = {
  async deploymentDefinition(_context: VuexContext, { categoryId, processKey, deploymentName }: any) {
    const config = getEnvironmentId();

    const xml = await fetch(`flow/rest/process-definition/key/${processKey}/xml${config}`, {
      credentials: "include",
    })
      .then(handleErrors)
      .then(async (data) => {
        return data.bpmn20Xml;
      });

    const fileName = `${deploymentName}.bpmn`;

    const xmlToBlob: any = new Blob([xml], {
      type: "application/octet-stream;charset=utf-8",
    } as any);

    const xmlTofile = new File([xmlToBlob], fileName);

    const FORM_DATA = new FormData();

    FORM_DATA.append("category-id", categoryId);
    FORM_DATA.append("process-id", processKey);
    FORM_DATA.append("deployment-name", deploymentName);
    FORM_DATA.append("data", xmlTofile, "data.bpmn");

    return fetch(
      `flow/api/process-definition/deployment-with-validation${config}`,
      {
        method: "POST",
        body: FORM_DATA,
      },
      true
    )
      .then(handleErrors)
      .then(async (data) => {
        return data;
      });
  },

  loadDeploymentCategories() {
    const config = getEnvironmentId();
    return fetch(`core/api/data/flow/categories${config}`)
      .then(handleErrors)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  },

  loadFlowUsers() {
    const config = getEnvironmentId();
    return fetch(`core/api/data/flow/users${config}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadFlowGroups() {
    const config = getEnvironmentId();
    return fetch(`core/api/data/flow/groups${config}`)
      .then(handleErrors)
      .then((data) => {
        return data;
      });
  },

  deployFlowUsers() {
    const config = getEnvironmentId();
    return fetch(`core/api/data/flow/users/deploy${config}`)
      .then(handleErrors)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  },

  deployFlowGroups() {
    const config = getEnvironmentId();
    return fetch(`core/api/data/flow/groups/deploy${config}`)
      .then(handleErrors)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  },

  loadProducts() {
    const config = getEnvironmentId();
    return fetch(`core/api/system/integration${config}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadScreens(_context: VuexContext, { product }: any) {
    const config = getEnvironmentId();
    return fetch(`core/api/external/screen/origin/${product}${config}`)
      .then(handleErrors)
      .then((res) => res)
      .catch((err) => err);
  },

  deployAPI(_context: VuexContext, { apiId }: any) {
    const config = getEnvironmentId();
    return fetch(`core/api/apicustom/${apiId}/deploy${config}`, {
      method: "POST",
    })
      .then(handleErrors)
      .then((data) => {
        return data;
      })
      .catch((err) => err);
  },
  testAPI(_context: VuexContext, { apiId }: any) {
    const config = getEnvironmentId();
    return fetch(`core/api/apicustom/${apiId}/execute${config}`, {
      method: "POST",
      body: JSON.stringify({}),
    })
      .then(handleErrors)
      .then((data) => {
        return data;
      })
      .catch((err) => err);
  },

  loadCategoriesByProcess(_context: VuexContext, { processId }: any) {
    const config = getEnvironmentId();
    return fetch(`core/api/data/flow/process-definition/${processId}/categories${config}`)
      .then(handleErrors)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  },

  loadDeploymentData(_context: VuexContext, { definitionId }: { definitionId: string }) {
    const config = getEnvironmentId();
    return fetch(`flow/api/deployment-data/${definitionId}${config}`)
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },
};

export const deployAPI = (apiId: string) => ({ type: "deployAPI", apiId });
export const testAPI = (apiId: string) => ({ type: "testAPI", apiId });
export const loadDeploymentCategories = () => ({ type: "loadDeploymentCategories" });
export const loadProducts = () => ({ type: "loadProducts" });
export const loadScreens = (product: string) => ({ type: "loadScreens", product });
export const loadFlowUsers = () => ({ type: "loadFlowUsers" });
export const loadFlowGroups = () => ({ type: "loadFlowGroups" });
export const deployFlowUsers = () => ({ type: "deployFlowUsers" });
export const deployFlowGroups = () => ({ type: "deployFlowGroups" });
export const deploymentDefinition = (categoryId: string, processKey: string, deploymentName: string) => ({
  type: "deploymentDefinition",
  categoryId,
  processKey,
  deploymentName,
});
export const loadCategoriesByProcess = (processId: string) => ({ type: "loadCategoriesByProcess", processId });
export const loadDeploymentData = (definitionId: string) => ({ type: "loadDeploymentData", definitionId });
